import { axiosPost } from "./ajaxServices";
import {
  urlGetShopOrderList,
  urlGetShopOrderDetail,
  urlUpdateShopOrderStatus,
  urlDeleteShopOrder,
} from "./CONSTANTS";

export const apiGetShopOrderList = (currentPage, pageSize, startDate, endDate, orderStatus = "") => {
  const url = urlGetShopOrderList;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("currentPage", currentPage);
  formData.append("pageSize", pageSize);
  formData.append("startDate", startDate);
  formData.append("endDate", endDate);
  formData.append("order_status", orderStatus);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const apiGetShopOrderDetail = (id) => {
  const url = urlGetShopOrderDetail;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("id", id);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export function apiUpdateShopOrderStatus(id, orderStatus) {
  const url = urlUpdateShopOrderStatus;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("id", id);
  formData.append("order_status", orderStatus);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export function apiDeleteShopOrder(id) {
  const url = urlDeleteShopOrder;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("id", id);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
